import ClientInfoDetailModal from './client-info-detail-modal.vue'
export default ClientInfoDetailModal
